module.exports = __webpack_public_path__ + "img/es.37300781.png";